(function () {
  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function whenMoneyReady(callback) {
    if (typeof window.fitnWhenMoneyReady === 'function') {
      window.fitnWhenMoneyReady().then(callback);
      return;
    }

    if (typeof window.fitnFormatMoney === 'function') {
      callback();
      return;
    }

    document.addEventListener('fitn:money-ready', callback, { once: true });
  }

  function formatMoney(cents, format, currency) {
    if (typeof window.fitnFormatMoney !== 'function') return null;

    var result = window.fitnFormatMoney(cents, format, currency);
    if (!result || result.indexOf('{{') !== -1) return null;

    return result;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateCartCount(count) {
    document.querySelectorAll('.fitn-cart-count').forEach(function (el) {
      el.dataset.count = String(count);
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function getPage() {
    return document.querySelector('[data-fitn-cart]');
  }

  function refreshSection() {
    var page = getPage();
    if (!page) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    if (!sectionId) return Promise.resolve();

    var url =
      cartRoot() +
      '?sections=' +
      encodeURIComponent(sectionId) +
      '&sections_url=' +
      encodeURIComponent(window.location.pathname);

    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-fitn-cart]');
        if (!next) return;

        page.replaceWith(next);
        bindPage();
        loadRecommendations();
      });
  }

  function changeLine(line, quantity) {
    var page = getPage();
    if (!page) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    page.classList.add('is-updating');

    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.errors) throw new Error(data.errors);

        updateCartCount(data.item_count);
        document.dispatchEvent(new CustomEvent('fitn:cart:update', { detail: { cart: data } }));

        if (data.sections && data.sections[sectionId]) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections[sectionId], 'text/html');
          var next = doc.querySelector('[data-fitn-cart]');
          if (next) {
            page.replaceWith(next);
            bindPage();
            loadRecommendations();
            return;
          }
        }

        return refreshSection();
      })
      .finally(function () {
        var current = getPage();
        if (current) current.classList.remove('is-updating');
      });
  }

  function applyDiscount(code) {
    var page = getPage();
    if (!page || !code) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    page.classList.add('is-updating');

    return fetch(cartRoot() + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var existing = (cart.cart_level_discount_applications || [])
          .map(function (discount) {
            return discount.title;
          })
          .filter(Boolean);

        if (existing.indexOf(code) !== -1) return existing.join(',');

        return existing.concat(code).join(',');
      })
      .then(function (discountValue) {
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: discountValue,
            sections: sectionId,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var invalid =
          data.discount_codes &&
          data.discount_codes.some(function (entry) {
            return entry.code === code && entry.applicable === false;
          });

        if (invalid) throw new Error('invalid');

        updateCartCount(data.item_count);
        document.dispatchEvent(new CustomEvent('fitn:cart:update', { detail: { cart: data } }));

        if (data.sections && data.sections[sectionId]) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections[sectionId], 'text/html');
          var next = doc.querySelector('[data-fitn-cart]');
          if (next) {
            page.replaceWith(next);
            bindPage();
            loadRecommendations();
          }
        } else {
          return refreshSection();
        }
      })
      .finally(function () {
        var current = getPage();
        if (current) current.classList.remove('is-updating');
      });
  }

  function loadRecommendations() {
    var page = getPage();
    if (!page) return;

    var grid = page.querySelector('[data-fitn-cart-recs-grid]');
    if (!grid || grid.children.length > 0) return;

    var productId = grid.getAttribute('data-product-id');
    if (!productId) return;

    var moneyFormat = page.dataset.moneyFormat || '${{amount}}';
    var currency = page.dataset.currency || '';
    var url =
      cartRoot() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=4&intent=related';

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data.products || !data.products.length) return;

        data.products.forEach(function (product) {
          var card = document.createElement('a');
          card.className = 'fitn-cart__rec';
          card.href = product.url;
          var imageSrc = window.FitnImages
            ? window.FitnImages.withWidth(product.featured_image, 1920)
            : product.featured_image || '';
          var imageSrcset = window.FitnImages ? window.FitnImages.productCard(product.featured_image) : '';
          card.innerHTML =
            '<div class="fitn-cart__rec-media"><img class="fitn-cart__rec-img" src="' +
            escapeHtml(imageSrc) +
            '"' +
            (imageSrcset ? ' srcset="' + escapeHtml(imageSrcset) + '" sizes="(min-width: 901px) 25vw, 50vw"' : '') +
            ' alt="' +
            escapeHtml(product.title) +
            '" loading="lazy"></div>' +
            '<h3 class="fitn-cart__rec-title">' +
            escapeHtml(product.title) +
            '</h3>' +
            '<p class="fitn-cart__rec-price">' +
            (formatMoney(product.price, moneyFormat, currency) || '') +
            '</p>';
          grid.appendChild(card);
        });
      })
      .catch(function () {});
  }

  function bindPage() {
    var page = getPage();
    if (!page) return;

    page.querySelectorAll('[data-fitn-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = Number(btn.getAttribute('data-fitn-cart-remove'));
        if (!line) return;
        changeLine(line, 0).catch(function () {});
      });
    });

    page.querySelectorAll('[data-fitn-cart-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-fitn-cart-line]');
        if (!item) return;

        var line = Number(item.getAttribute('data-fitn-cart-line'));
        var valueEl = item.querySelector('[data-fitn-cart-qty-value]');
        var current = valueEl ? Number(valueEl.textContent) : 1;
        var delta = Number(btn.getAttribute('data-fitn-cart-qty-change'));
        var nextQty = Math.max(1, current + delta);

        if (nextQty === current) return;
        changeLine(line, nextQty).catch(function () {});
      });
    });

    var discountForm = page.querySelector('[data-fitn-cart-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = discountForm.querySelector('input[name="discount"]');
        var error = page.querySelector('[data-fitn-cart-discount-error]');
        if (!(input instanceof HTMLInputElement) || !input.value.trim()) return;

        if (error) error.hidden = true;

        applyDiscount(input.value.trim())
          .then(function () {
            input.value = '';
          })
          .catch(function () {
            if (error) error.hidden = false;
          });
      });
    }
  }

  function boot() {
    bindPage();
    whenMoneyReady(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
